import { render, staticRenderFns } from "./ReviewWritingNotification.vue?vue&type=template&id=5897cfe3&"
import script from "./ReviewWritingNotification.vue?vue&type=script&lang=js&"
export * from "./ReviewWritingNotification.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports